import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Injectable()
export class GetImage {
  private _api: ApiService;
  private sanitizer: DomSanitizer;

  constructor(_api: ApiService, sanitizer: DomSanitizer) {
    this._api = _api;
    this.sanitizer = sanitizer;
  }

  user(id: string): any {
    return new Observable((observer) => {
      this._api.getIcon(`/user/${id}/icon`).subscribe(
        (image: Blob) => {
          if (image) {
            const imageUrl = this.createImageFromBlob(image);
            observer.next(imageUrl);
            observer.complete();
          }
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }
  organization(id: string): any {
    return new Observable((observer) => {
      this._api.getIcon(`/organization/${id}/icon`).subscribe(
        (image: Blob) => {
          const imageUrl = this.createImageFromBlob(image);
          observer.next(imageUrl);
          observer.complete();
        },
        (error) => {
          observer.next(null);
          observer.complete();
        },
      );
    });
  }
  getDiagramImage(uriLabel, conceptId) {
    return new Observable((observer) => {
      this._api.getDiagram(`/project/${uriLabel}/concept/${conceptId}/diagram`).subscribe(
        (image: Blob) => {
          if (image) {
            const imageUrl = this.createImageFromBlob(image);
            observer.next(imageUrl);
            observer.complete();
          }
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }
  createImageFromBlob(image: Blob) {
    if (!image) return '';
    const blob = new Blob([image], { type: 'image/png' });
    const unsafeImageUrl = URL?.createObjectURL(blob);
    return this.sanitizer?.bypassSecurityTrustUrl(unsafeImageUrl);
  }
}
